@use './spinner-utility';
@use './spinner-vars';
@use './spinner-common';

:host {
  @include spinner-vars.wb-spinner-vars;
  @include spinner-common.wb-spinner;

  .inner {
    @include spinner-common.wb-spinner-inner;
  }
}

:host([paused]) .inner {
  @include spinner-common.wb-spinner-paused;
}

:host([theme='dark']) {
  @include spinner-vars.wb-spinner-vars-dark;
}

:host([theme='blue']) {
  @include spinner-vars.wb-spinner-vars-blue;
}
